/*
    Create by fanglijuan 2016-05-10
*/
'use strict';
angular.module('moveUserModule', []).controller('moveUserCtrl', [
    '$scope',
    'modalDialog',
    '$timeout',
    '$modalInstance',
    'trsHttpService',
    'treeService',
    '$state',
    'globleParamsSet',
    'userManageMentService',
    'incommData',
    'trsGroupTreeLocationService',
    function(
        $scope,
        modalDialog,
        $timeout,
        $modalInstance,
        trsHttpService,
        treeService,
        $state,
        globleParamsSet,
        userManageMentService,
        incommData,
        trsGroupTreeLocationService
    ) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化参数
         */
        function initStatus() {
            $scope.status = {
                ifExpand: true,
                userGroup: '用户所属组织',
                treeOptions: {
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'copyDraftTree-ul',
                        li: 'copyDraftTree-li',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'copyDraftTree-label',
                        labelSelected: 'rolegrouplabselected',
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === 'false';
                    },
                },
            };
            $scope.data = {
                modalTitle: incommData.moveType === 'move' ? '移动用户' : incommData.moveType === 'add' ? '添加到组织' : '迁移到租户',
                selectedGroup: '',
                fromGroupId: incommData.parentGroupId,
                rootGroupId: 1,
            };
            $scope.params = {
                ToGroupId: '',
            };
        }
        /**
         * [showToggle description]树展开方法
         * @param  {[obj]} node [description]父节点
         * @return {[type]}        [description]
         */
        $scope.showToggle = function(node) {
            if (node.HASCHILDREN === 'false' || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length !== 0)) return;
            treeService.queryChildGroupsWithSecondRight(node.GROUPID).then(function(data) {
                node.CHILDREN = data.CHILDREN;
            });
        };
        /**
         * [showSelected description]点击组织树节点
         * @param  {[obj]} node [description]点击的节点
         * @return {[type]}        [description]
         */
        $scope.showSelected = function(node) {
            $scope.GroupId = node.GROUPID;
        };

        /**
         * [description] 判断节点是否禁用
         */
        $scope.isDisabled = function(node) {
            return node.GROUPID === $scope.data.fromGroupId || node.GROUPID == $scope.data.rootGroupId ? true : false;
        };

        /**
         * [initData description]初始化数据
         */
        function initData() {
            getTreeData();
        }
        $scope.chooseGroup = function(node) {
            if ($scope.isDisabled(node)) return;
            $scope.data.selectedGroup = node;
        };
        /**
         * [getTreeData description]获取树数据
         * @param  {[obj]} params [description]请求参数
         * @param  {[string]} roleid   [description]角色Id非必传
         * @return {[type]}        [description]
         */
        function getTreeData() {
            treeService.queryGroupTreeWithSecondRight().then(function(data) {
                $scope.data.treeData = [data];
                ExpandedNodes();
            });
        }

        /**
         * [ExpandedNodes 默认展开树开始]
         *
         * @return  {[type]}  [return description]
         */
        function ExpandedNodes() {
            $scope.expandedTest = [];
            $scope.expandedTest.push($scope.data.treeData[0]);
            if ($scope.data.treeData[0].CHILDREN === 0) {
                $scope.selectedNode = $scope.data.treeData[0];
                getGroupData($scope.selectedNode);
            } else {
                angular.forEach($scope.data.treeData[0].CHILDREN, function(data, index, array) {
                    if (data.ISPATH === 'true') {
                        $scope.expandedTest.push(data);
                        if (data.CHILDREN.length !== 0) {
                            selfPath(data);
                        } else {
                            $scope.selectedNode = data;
                            getGroupData($scope.selectedNode);
                        }
                    }
                });
            }
        }
        
        /**
         * [getGroupData 默认展开树结束]
         *
         * @param   {[type]}  node  [node description]
         *
         * @return  {[type]}        [return description]
         */
        function getGroupData(node) {
            $timeout(function() {
                //此判断如果两次点击同一个树，不重复加载角色列表。
                if ($scope.oldSelectNode !== undefined && node.GROUPID == $scope.oldSelectNode.GROUPID) {
                    return;
                }
                $scope.groupObj = node;
                $scope.oldSelectNode = node;
                $scope.roleDatas = [];
                $scope.roleData = null;
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'query',
                    GroupId: $scope.groupObj.GROUPID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function(data) {
                        $scope.data.roleDatas = data;
                    },
                    function(data) {
                        modalDialog.alertType('错误提示', '获取数据失败', 'warning', false);
                    }
                );
            }, 100);
        }
        //点击树回调函数开始
        $scope.showSelected = function(node) {
            getGroupData(node);
        };
        //点击树回调函数结束

        /**
         * [moveUser 移动用户到组织方法]
         *
         * @param   {[type]}  ToGroupId  [ToGroupId description]
         *
         * @return  {[type]}             [return description]
         */
        function moveUser(ToGroupId) {
            var params = {
                serviceid: 'mlf_usermanagement',
                methodname: 'moveUserToGroup',
                UserIds: incommData.userIds,
                FromGroupId: incommData.parentGroupId,
                ToGroupId: ToGroupId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('用户移动成功', '', 'success', false, function() {
                    $modalInstance.close('success');
                });
            });
        }
        
        /**
         * [addUsersToGroup (未分配用户列表)添加用户到组织方法]
         *
         * @param   {[type]}  ToGroupId  [ToGroupId description]
         *
         * @return  {[type]}             [return description]
         */
        function addUsersToGroup(ToGroupId) {
            var params = {
                serviceid: 'mlf_usermanagement',
                methodname: 'addUsersToGroup',
                UserIds: incommData.userIds,
                GroupId: ToGroupId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('用户添加成功', '', 'success', false, function() {
                    $modalInstance.close('success');
                });
            });
        }
        //确定
        $scope.confirm = function() {
            $scope.params.ToGroupId = $scope.data.selectedGroup.GROUPID;
            if (incommData.moveType == 'move') {
                //移动用户到组织
                moveUser($scope.params.ToGroupId);
            } else if (incommData.moveType == 'add') {
                //(未分配用户列表)添加用户到组织
                addUsersToGroup($scope.params.ToGroupId);
            } else if (incommData.moveType == 'toTenant') {
                moveUserToTenant($scope.data.selectedGroup);
            }
        };

        /**
         * [moveUserToTenant 用户迁移到其它租户下]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function moveUserToTenant (item) {
            const params = {
                serviceid: 'mlf_usermanagement',
                methodname: 'cancelZmyBindUsers',
                UserId: incommData.userIds,
                TargetTenantId: item.TENANTID,
                TargetGroupId: item.GROUPID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('迁移租户成功', '', 'success', false, function() {
                    $modalInstance.close('success');
                });
            });

        }

        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [getSuggestions] 匹配搜索框内关键词
         */
        var promise;
        $scope.getSuggestions = function(groupName) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function() {
                if (groupName !== '') {
                    var params = {
                        serviceid: 'mlf_extuser',
                        methodname: 'searchGroup',
                        Name: groupName,
                    };
                    if ($scope.status.isRequest) {
                        $scope.status.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            return data;
                        });
                    }
                }
            }, 10);
            return promise;
        };

        $scope.$watch('status.searchGroup', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                $scope.status.isRequest = true;
                locationGroupTree(newValue.GROUPIDS);
                //expandTreeAndSelectNode(newValue.GROUPIDS);
                $scope.status.searchGroup = newValue.GNAME;
            }
        });

        /*$scope.groupSearch = function() {
            if(angular.isObject($scope.status.searchGroup)) {
                // $scope.status.isRequest = true;
                locationGroupTree($scope.status.searchGroup.GROUPIDS);
                //expandTreeAndSelectNode(newValue.GROUPIDS);
                // $scope.status.searchGroup = $scope.status.searchGroup.GNAME;
            } else {
                modalDialog.alertType("请先选中组织后再进行搜索", "", "error", false);
            }
        };*/

        /**
         * [locationGroupTree description] 定位目标节点在组织树中的位置
         * @param  {[type]} gropuIds [description]
         * @return {[type]}          [description]
         */
        function locationGroupTree(gropuIds) {
            $scope.expandedTest = [];
            var groupidsArray = gropuIds.split(',');
            groupidsArray.splice(0, 1);
            if (groupidsArray.length === 0) {
                $timeout(function() {
                    $scope.selectedNode = $scope.data.treeData[0];
                    $scope.data.selectedGroup = $scope.data.treeData[0];
                });
                return;
            }
            trsGroupTreeLocationService.groupTreeLocation(groupidsArray, $scope.data.treeData[0], $scope.selectedNode, $scope.expandedTest, function(
                tree,
                array,
                selectedNode
            ) {
                delete $scope.data.treeData;
                $scope.data.treeData = [tree];
                $scope.expandedTest.push($scope.data.treeData[0]);
                $scope.selectedNode = selectedNode;
                $scope.data.selectedGroup = selectedNode;
            });
        }
    },
]);
